import { render, staticRenderFns } from "./RemoteInviteShowModal.vue?vue&type=template&id=488a17d0&"
import script from "./RemoteInviteShowModal.vue?vue&type=script&lang=js&"
export * from "./RemoteInviteShowModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports